import { action, atom, withAssign, withInit } from '@reatom/framework'

import type { Action, Atom, AtomMut, Ctx } from '@reatom/framework'

type ReatomStringArrayInput = Atom<Array<string>> & {
  raw: AtomMut<string>
  setRaw: Action<[raw: string], void>
}

type ReatomStringArrayInputArgs = {
  initial: string | ((ctx: Ctx) => string | Array<string>)
  joiner: string
}

export const reatomStringArrayInput = (
  args: ReatomStringArrayInputArgs,
  name?: string,
): ReatomStringArrayInput => {
  const stringArrayRawAtom = atom('', `${name}.stringArrayRawAtom`).pipe(
    withInit((ctx) => {
      const initial =
        typeof args.initial === 'function' ? args.initial(ctx) : args.initial

      if (Array.isArray(initial)) {
        return initial.join(args.joiner)
      }
      return initial
    }),
  )
  const setStringArrayRawAction = action((ctx, raw: string) => {
    stringArrayRawAtom(ctx, raw)
  }, `${name}.setStringArrayRawAction`)

  const stringArrayAtom = atom((ctx) => {
    const raw = ctx.spy(stringArrayRawAtom)

    return raw
      .split(args.joiner)
      .map((x) => x.trim())
      .filter((x) => !!x)
  }, `${name}.stringArrayAtom`)

  return stringArrayAtom.pipe(
    withAssign(() => ({
      raw: stringArrayRawAtom,
      setRaw: setStringArrayRawAction,
    })),
  )
}
